import * as React from 'react';

const SvgMinusOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M4.531 11.469a.75.75 0 0 0 0 1.5h6.744a1 1 0 0 0 .11-.008.1.1 0 0 1 .035 0 1 1 0 0 0 .111.008h7a.75.75 0 1 0 0-1.5h-7a1 1 0 0 0-.111.008.1.1 0 0 1-.034 0 1 1 0 0 0-.111-.008z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgMinusOutlined;
